// SHARED-008: Currency display component
import { formatFlop, formatAGI } from '../utils/formatters';

const CURRENCY_ICONS: Record<string, string> = {
  flop: '/assets/icons/currency/icon_currency_flop.webp',
  agi: '/assets/icons/currency/icon_currency_agi.webp',
};

interface CurrencyDisplayProps {
  type: 'flop' | 'agi';
  amount: number;
  className?: string;
}

export function CurrencyDisplay({ type, amount, className = '' }: CurrencyDisplayProps) {
  const formatted = type === 'flop' ? formatFlop(amount) : formatAGI(amount);
  const color = type === 'flop' ? 'var(--color-element-yellow)' : 'var(--color-element-purple)';

  return (
    <span className={className} style={{
      color,
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--font-size-md)',
      fontWeight: 600,
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
    }}>
      <img
        src={CURRENCY_ICONS[type]}
        alt={type}
        style={{ width: '18px', height: '18px', objectFit: 'contain' }}
      />
      {formatted}
    </span>
  );
}
